import Img from 'gatsby-image';
import React, { useContext } from 'react';
import { Button } from '../components';
import AppContext from '../context';
import { CardWrapper } from '../elements';
import { Tags } from './Tags';

export const ContentCard = ({
  date,
  title,
  excerpt,
  slug,
  image,
  author,
  readTime,
  index,
  tags,
  extension,
  publicURL,
}) => {
  const img = image.childImageSharp?.fixed;
  const { dark } = useContext(AppContext);

  const imageStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  };

  return (
    <CardWrapper style={index === 0 ? { marginTop: 0 } : {}} dark={dark}>
      <div className='image-container'>
        {!img && extension === 'svg' ? (
          <img
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              height: '100%',
            }}
            src={publicURL}
            alt='Image not found'
          />
        ) : (
          <Img fixed={img} style={imageStyle} />
        )}
      </div>
      <div className='content-container'>
        <div className='title'>{title}</div>
        <p className='excerpt'>{excerpt}</p>

        <div className='author-info'>{author}</div>
        <div className='date'>
          <span style={{ marginRight: '0.25rem' }}>{date}</span>{' '}
          <span> &bull; </span>
          <span style={{ marginLeft: '0.25rem' }}>{readTime}</span>
        </div>
        <Tags tags={tags} />
        <div className='button-container'>
          <Button href={`${slug}`}>Read</Button>
        </div>
      </div>
    </CardWrapper>
  );
};
